import { createFileRoute } from '@tanstack/react-router';

import { FriendGamePageWidget } from '@features/game/pages/FriendGamePage/FriendGamePageWidget';
import { FriendGameViewProvider } from '@features/game/providers/FriendGameProvider';

export const Route = createFileRoute('/game/friend_/$gameId_/view')({
  component: Page,
});

function Page() {
  const { gameId } = Route.useParams();

  return (
    <FriendGameViewProvider inviteId={gameId}>
      <FriendGamePageWidget key={gameId} gameId={gameId} isView />
    </FriendGameViewProvider>
  );
}
